import { Feature, Point } from "geojson";
import { TStation, TStationFeatureProps, TStationsGeoJson, TStationType } from "../types/station-types";
import { TMarkerType } from "../types/marker-types";

export const convertStationsToGeoJson = (stations: Array<TStation>): TStationsGeoJson => {
  const stationsAsGeoJson: Array<Feature<Point, TStationFeatureProps>> = stations.map((station) => {
    return {
      type: "Feature",
      id: station.stationCode ? station.stationCode : 0,
      geometry: {
        type: "Point",
        /*
          for some RANDOM reason GeoJson uses [lng, lat] instead of [lat, lng] like
          the rest of the world and uses array so the types won't catch the problem.

          "The first two elements are longitude and latitude, or
          easting and northing, precisely in that order and using decimal
          numbers.""
        */
        coordinates: [station.longitude ? station.longitude : 0, station.latitude ? station.latitude : 0],
      },
      properties: {
        station: station,
      },
    };
  });

  return {
    type: "FeatureCollection",
    features: stationsAsGeoJson,
  };
};

export const getMarkerTypeForStation = (station: TStation): TMarkerType => {
  const stationType: TStationType = station?.stationType;

  switch (stationType) {
    case "01 Bemannad":
    case "02 Automat": {
      if (station.stationConcept === "22 Uno X Truck" || station.stationConcept === "21 Uno X") {
        return "Uno X";
      }

      if (station.stationConcept === "20 Preem Truck YX") {
        return "YX";
      }

      return "Preem";
    }
    case "03 TRUCK": {
      return "Såifa";
    }

    default:
      return "Preem";
  }
};

export const getScaleForZoomLevel = (zoomLevel: number) => {
  //lower number is more zoomed out
  switch (zoomLevel) {
    case 10: {
      return 1;
    }
    case 9: {
      return 0.95;
    }
    case 8: {
      return 0.85;
    }
    case 7: {
      return 0.65;
    }
    case 6: {
      return 0.35;
    }
    case 5: {
      return 0.25;
    }

    default: {
      return 1;
    }
  }
};
